/*! facett renewal — Why facett
 * xl以上: 3カラム／lg: 2カラム／lg未満: SCENE 同型スライダー
 * Hero 非干渉: data-facett-why のみ
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var GAP = 16;
  var MQ_LG = '(min-width: 992px)';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function isLgUp() {
    return window.matchMedia(MQ_LG).matches;
  }

  function getInsetPx(root) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(--facett-why-inset)';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || 0;
  }

  function getCardW(root) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(--facett-why-card-w)';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || 348;
  }

  function needsSwipe(el, slideCount, inset, cardW) {
    if (!el || slideCount <= 1) return false;
    var w = cardW || 348;
    var total = slideCount * w + Math.max(0, slideCount - 1) * GAP + inset * 2;
    return total > el.clientWidth + 1;
  }

  function destroyWhy(root) {
    if (!root) return;
    if (root._facettWhySwiper && typeof root._facettWhySwiper.destroy === 'function') {
      try {
        root._facettWhySwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettWhySwiper = null;
    root.dataset.facettWhyReady = '';
  }

  function setStatic(root, on) {
    root.classList.toggle('facett-why--static', !!on);
  }

  function setGrid(root, on) {
    root.classList.toggle('facett-why--grid', !!on);
  }

  function initWhy(root) {
    if (!root) return;

    var el = root.querySelector('[data-facett-why-swiper]');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    var layout = root.getAttribute('data-facett-why-layout') || 'auto';

    destroyWhy(root);

    /* 2列×3行固定（下層ハブ等） */
    if (layout === 'grid_2x3') {
      root.classList.remove('facett-why--single');
      setGrid(root, true);
      setStatic(root, true);
      root.classList.add('facett-why--grid-2x3');
      root.dataset.facettWhyReady = '1';
      return;
    }

    setStatic(root, false);
    setGrid(root, false);
    root.classList.remove('facett-why--grid-2x3');

    if (count <= 1) {
      root.classList.add('facett-why--single');
      setStatic(root, true);
      if (isLgUp()) setGrid(root, true);
      root.dataset.facettWhyReady = '1';
      return;
    }

    root.classList.remove('facett-why--single');

    /* lg以上: グリッド（2 / 3 列は CSS） */
    if (isLgUp()) {
      setGrid(root, true);
      setStatic(root, true);
      root.dataset.facettWhyReady = '1';
      return;
    }

    var inset = getInsetPx(root);
    var cardW = getCardW(root);

    if (!needsSwipe(el, count, inset, cardW)) {
      setStatic(root, true);
      root.dataset.facettWhyReady = '1';
      return;
    }

    setStatic(root, false);

    if (!window.Swiper) return;

    var paginationEl = root.querySelector('[data-facett-why-pagination]');
    root._facettWhySwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: GAP,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      a11y: {
        enabled: true,
      },
    });

    if (root._facettWhySwiper.isLocked) {
      destroyWhy(root);
      setStatic(root, true);
    }

    root.dataset.facettWhyReady = '1';
  }

  function anyNeedsSwipe(roots) {
    if (isLgUp()) return false;
    return Array.prototype.some.call(roots, function (root) {
      if ((root.getAttribute('data-facett-why-layout') || 'auto') === 'grid_2x3') {
        return false;
      }
      var el = root.querySelector('[data-facett-why-swiper]');
      if (!el) return false;
      var count = el.querySelectorAll('.swiper-slide').length;
      if (count <= 1) return false;
      return needsSwipe(el, count, getInsetPx(root), getCardW(root));
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-why]').forEach(function (root) {
      initWhy(root);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-why]');
    if (!roots.length) return;

    if (anyNeedsSwipe(roots)) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(syncAll);
        })
        .catch(function () {
          syncAll();
        });
      return;
    }

    syncAll();
    window.requestAnimationFrame(syncAll);
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-why]');
    if (root) {
      destroyWhy(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-why]');
    if (root) {
      destroyWhy(root);
    }
  });
})();
